PopOver = require 'app/scripts/views/lib/pop-over'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
_ = require 'underscore'
template = require 'app/scripts/views/templates/checklist_add_menu'
{ track } = require '@trello/analytics'
ModelCache = require 'app/scripts/db/model-cache'

alphabeticallyOn = (field) -> (a, b) -> a.get(field).localeCompare b.get(field)

module.exports = class AddChecklistMenu extends View
  viewTitleKey: 'add checklist'

  initialize: ({ @cardView }) ->

  events:
    'click .js-add-checklist': 'addChecklist'
    'submit form': 'addChecklist'
    'change .js-checklist-copy-source': 'changeSource'
    'input .js-checklist-title': (e) ->
      @$('.js-checklist-title').attr('data-changed', true)

  _canAddChecklist: (model, limitType) ->
    !model.isOverLimit('checklists', limitType)

  render: ->
    checklistCards = @modelCache.find 'Card', (card) =>
      card.get('idBoard') == @model.getBoard().id &&
      card.isOpen() &&
      card.checklistList.length > 0
    .sort alphabeticallyOn('name')
    .map (card) ->
      name: card.get('name')
      checklists: card.checklistList.chain()
        .clone()
        .sort alphabeticallyOn('name')
        .map (checklist) ->
          id: checklist.id
          name: checklist.get('name')
        .value()

    @$el.html template({
      checklistCards,
      canAddChecklistCard: @_canAddChecklist(@model, 'perCard'),
      canAddChecklistBoard: @_canAddChecklist(@model.getBoard(), 'perBoard')
    })

    @

  addChecklist: (e) ->
    Util.stop(e)

    if !(@_canAddChecklist(@model, 'perCard') &&
    @_canAddChecklist(@model.getBoard(), 'perBoard'))
      @render()
      return

    title = @$('.js-checklist-title').val()
    idChecklistSource = @$('.js-checklist-copy-source').val()

    if title.length == 0
      @$('.js-checklist-title').focus().select()
      return

    if idChecklistSource != ""
      copiedText = "Copied Checklist Items"
    else
      copiedText = "No Checklist Items Copied"

    if title == "Checklist"
      gaActionText = "Default Title (Checklist), #{copiedText})"
    else
      gaActionText = "Renamed Title, #{copiedText})"

    track("Checklist", "Create", "#{gaActionText}")

    checklist = @model.checklistList.create
      name: title
      idChecklistSource: idChecklistSource
      idCard: @model.id
    ,
      error: =>
        # The checklist is optimisitically added.
        # If the add fails, remove the checklist
        @model.checklistList.remove(checklist)

    @cardView.focusChecklistAdd(checklist)

    PopOver.hide()

    return

  changeSource: (e) ->
    $checklistTitle = @$('.js-checklist-title')
    defaultName = $checklistTitle.attr('data-default')

    # If they've modified it to something other than the default/blank don't overwrite their input
    if $checklistTitle.attr('data-changed') && $checklistTitle.val() && $checklistTitle.val() != defaultName
      return

    idChecklistSource = @$('.js-checklist-copy-source').val()
    newName =
      if idChecklistSource && (sourceChecklist = ModelCache.get('Checklist', idChecklistSource))?
        sourceChecklist.get('name')
      else
        defaultName

    $checklistTitle.val(newName).removeAttr('data-changed')
